import React from 'react';

const Partners = () => {
    return (
        <section className="py-4 bg-slate-50/50 border-b border-slate-100">
            <div className="section-padding text-center">
                <h2 className="heading-lg mb-4"><span className="gradient-text font-black">Partners</span> in Our Journey</h2>
                <div className="flex justify-center items-center">
                    {/* The User's Specific Partner: Repion */}
                    <a
                        href="http://repion.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block transition-transform duration-300 hover:scale-105"
                    >
                        <img
                            className="h-12 md:h-16 w-auto object-contain drop-shadow-sm"
                            alt="Repion Badge"
                            src="https://images.weserv.nl/?url=repion.com/__static/06d49f60258fc1612b84ca4d5a2fab21/rep-badge.png"
                        />
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Partners;
